if (typeof jQuery === "undefined") {
	throw new Error("Erreur : jQuery est requis.");
}

var $ = jQuery.noConflict(),
	$carousel = $(".carousel");

var Application = (function () {
	var transformSVG = function () {
		$("img.svg").each(function () {
			var $img = jQuery(this);
			var imgID = $img.attr("id");
			var imgClass = $img.attr("class");
			var imgURL = $img.attr("src");

			$.get(
				imgURL,
				function (data) {
					var $svg = $(data).find("svg");

					if (typeof imgID !== "undefined") {
						$svg = $svg.attr("id", imgID);
					}

					if (typeof imgClass !== "undefined") {
						$svg = $svg.attr("class", imgClass + " replaced-svg");
					}

					$svg = $svg.removeAttr("xmlns:a");

					if (
						!$svg.attr("viewBox") &&
						$svg.attr("height") &&
						$svg.attr("width")
					) {
						$svg.attr(
							"viewBox",
							"0 0 " + $svg.attr("height") + " " + $svg.attr("width")
						);
					}

					$img.replaceWith($svg);
				},
				"xml"
			);
		});
	};

	var initMainNavigation = function () {
		var $menu = $(".navbar__bottom ul");

		$menu.menuAim({
			triggerEvent: "hover",
			activateCallback: activate,
			deactivateCallback: deactivate,
			submenuDirection: "below",
			activationDelay: 100,
			openClassName: "maintainHover",
			mouseLocsTracked: 4,
			tolerance: 200,
		});

		function activate(row) {
			var $row = $(row),
				$submenu = $row.children(".dropdown");

			$row.addClass("maintainHover");

			$submenu.css({
				opacity: 1,
				visibility: "visible",
				display: "block",
			});
		}

		function deactivate(row) {
			var $row = $(row),
				$submenu = $row.children(".dropdown");

			$row.removeClass("maintainHover");

			$submenu.css({
				opacity: 0,
				visibility: "hidden",
				display: "none",
			});
		}
	};

	var adaptativeHeight = function () {
		height1 = $("#dropdown__portail").height() + 110;
		height2 = $("#dropdown__vie").height() + 110;
		height3 = $("#dropdown__culture").height() + 110;
		height4 = $("#dropdown__affaires").height() + 110;
		height5 = $("#dropdown__choisir").height() + 110;
		height6 = $("#dropdown__tourisme").height() + 110;

		height = Math.max(height1, height2, height3, height4, height5, height6);

		$(".drop, .navbar__bottom_drop, .dropdown").css("height", height);
	};

	var scrollToHashedPart = function () {
		if (window.location.hash) {
			var hash = window.location.hash;

			if ($(hash).length > 0) {
				var position = $(hash).offset().top;

				if ($("body").hasClass("admin-bar")) {
					position = position - $("#wpadminbar").height();
				}

				$("html, body").animate(
					{
						scrollTop: position,
					},
					400,
					function () {
						$(hash).parent().addClass("open");

						var refresh =
							window.location.protocol +
							"//" +
							window.location.host +
							window.location.pathname +
							"#" +
							hash;

						$(".module__share_header .facebook, .module__share_header .twitter")
							.find("a")
							.attr("data-url", encodeURIComponent(refresh));
					}
				);
			}
		}
	};

	return {
		init: function () {
			transformSVG();
			initMainNavigation();
			adaptativeHeight();
			scrollToHashedPart();
		},

		openSearch: function () {
			$(".search__form").toggleClass("hidden");

			if (!$(".search__form").hasClass("hidden")) {
				$(".search__form").find("input").focus();
			}
		},

		doSearch: function () {
			$("#searchform").submit();
		},

		resize: function () {
			adaptativeHeight();
		},
	};
})();

$(window).on("resize", function () {
	Application.resize();
});

$(document).ready(function () {
	"use strict";

	Application.init();

	$(".scrollup").on("click", function () {
		$("html, body").animate(
			{
				scrollTop: 0,
			},
			600
		);
		return false;
	});

	// Search results scroll
	$(".search__results_types .type").on("click", function (event) {
		console.log(event);

		// Make sure this.hash has a value before overriding default behavior
		if ($(this).data("tag") !== "") {
			// Prevent default anchor click behavior
			event.preventDefault();

			// Store hash
			var hash = $(this).data("tag");

			// Using jQuery's animate() method to add smooth page scroll
			// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
			$("html, body").animate(
				{
					scrollTop: $("#group_" + hash).offset().top,
				},
				800,
				function () {
					// Add hash (#) to URL when done scrolling (default click behavior)
					window.location.hash = "group_" + hash;
				}
			);
		} // End if
	});

	// Simple date picker
	$(".datepicker").datepicker({
		minDate: new Date(2019, 10 - 1, 9),
	});
	$.datepicker.setDefaults($.datepicker.regional["fr-CA"]);

	// Accordion
	var $accordion = $(".accordion li .section__title");

	$accordion.on("click", function () {
		if (!$(this).parent().hasClass("open")) {
			// Close all other siblings
			$(".accordion li").removeClass("open");
		}

		// Open current sibling
		$(this).parent().toggleClass("open");

		if ($(this).parent().hasClass("open")) {
			// Scroll to the current sibling
			$("html, body").animate(
				{
					scrollTop: $(this).offset().top,
				},
				250
			);

			// Add hash to current page URL
			var refresh =
				window.location.protocol +
				"//" +
				window.location.host +
				window.location.pathname +
				"#" +
				$(this).attr("id");
			window.history.pushState({ path: refresh }, "", refresh);

			// Refresh the "Share page" URL data set
			$(".module__share_header .link").find("a").attr("data-url", refresh);
			$(".module__share_header .facebook, .module__share_header .twitter")
				.find("a")
				.attr("data-url", encodeURIComponent(refresh));
		}
	});

	var $el = $(".slick__carousel");

	// Init
	$el.on("init", function (event, slick) {
		console.log("Init");
	});

	// Gutenberg Galerie
	$(document).on("click", '[data-toggle="lightbox"]', function (event) {
		event.preventDefault();
		$(this).ekkoLightbox();
	});

	$el.slick({
		fade: true,
		prevArrow:
			'<span class="slick-prev" title="Précédent"><i class="fal fa-chevron-left"></i></span>',
		nextArrow:
			'<span class="slick-next" title="Suivant"><i class="fal fa-chevron-right"></i></span>',
		cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
		touchThreshold: 100,
		lazyLoad: "ondemand",
	});

	// On before slide change
	$el.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
		$el.addClass("beforeChange");

		$(".slide__content").css({
			transform: "translate(-100%,0)",
		});

		console.log(currentSlide, nextSlide);
	});

	// On before slide change
	$el.on("afterChange", function (event, slick, currentSlide) {
		$(".slide__content").css({
			transform: "translate(0,0)",
		});

		console.log(currentSlide);
	});

	$carousel.carousel({
		interval: false,
		pause: "hover",
		keyboard: true,
	});

	$carousel.on("slide.bs.carousel", function (e) {});

	$carousel.on("slid.bs.carousel", function (e) {
		var slide__id = e.relatedTarget;
		carousel__slided(e);
	});

	$(".carousel__control").bind("click", function (e) {
		$carousel.carousel("pause");

		if ($(this).hasClass("prev")) {
			carousel__slide("prev");
		}

		if ($(this).hasClass("next")) {
			carousel__slide("next");
		}
	});

	var timer = null;

	$carousel
		.mouseenter(function () {
			if (timer) {
				clearInterval(timer);
				console.log("paused");
			}
		})
		.mouseleave(function () {
			console.log("mouse leave");

			timer = setInterval(function () {
				console.log("next");
				carousel__slide("next");
			}, 7000);
		})
		.mouseleave();

	// Mobile menu
	var $hamburger = $(".hamburger");

	$hamburger.on("click", function (e) {
		$hamburger.toggleClass("is-active");

		// Remove scroll
		$("html").toggleClass("noscroll mobile__menu_active");

		if ($hamburger.hasClass("is-active")) {
			mobile__slide_animation_first_level();
		} else {
			$(
				".first__level__menu, .navigation__menu_bottom, .second__level_menu *"
			).removeClass("visible");
			$(
				".first__level__menu, .second__level_menu, .second__level_menu > ul > li"
			).removeClass("active");
			$(".first__level__menu, .second__level_menu > ul > li").show();
		}

		// Do something else, like open/close menu
		$(".mobile__navigation .navigation").toggleClass("hidden");
	});

	// First level click
	$(".first__level__menu .page__title").on("click", function (e) {
		if (!$(this).parent().hasClass("active")) {
			$(this).parent().addClass("active");

			$(this).parent().find(".second__level_menu").addClass("active");

			mobile__hide_other_first_levels();

			mobile__slide_animation_second_level();
		} else {
			$(this).parent().removeClass("active");
			$(this).parent().find(".second__level_menu").removeClass("active");
			$(this)
				.parent()
				.find(".second__level_menu > ul > li")
				.removeClass("active");
			$(this)
				.parent()
				.find(".second__level_menu > ul > li > a")
				.removeClass("visible");

			mobile__show_other_first_levels();
			mobile__show_other_second_levels();
		}
	});

	// Second level click
	$(".second__level_menu > ul > li > a").on("click dblclick", function (e) {
		if ($(this).parent().hasClass("page_item_has_children")) {
			e.preventDefault();

			if (!$(this).parent().hasClass("active")) {
				$(this).parent().addClass("active");

				mobile__hide_other_second_levels();

				mobile__slide_animation_thrid_level();
			} else {
				$(this).parent().removeClass("active");

				mobile__show_other_second_levels();
			}
		}
	});
});

function mobile__go_to_step2() {
	$(".navigation__menu").addClass("step2");

	if ($(".navigation__menu").hasClass("step2")) {
		$('.first__level__menu:not(".active")').hide();
	}
}

function mobile__slide_animation_first_level() {
	$("html.mobile__menu_active")
		.find(".first__level__menu")
		.each(function (i) {
			setTimeout(function () {
				$("html.mobile__menu_active")
					.find(".first__level__menu")
					.eq(i)
					.addClass("visible");
			}, 50 * i);

			setTimeout(function () {
				$(".navigation__menu_bottom").addClass("visible");
			}, 600);
		});
}

function mobile__hide_other_first_levels() {
	$(".first__level__menu").each(function () {
		if (!$(this).hasClass("active")) {
			$(this).hide();

			// Remove visible states
			$(".second__level_menu > ul > li").removeClass("visible");
		} else {
			return;
		}
	});
}

function mobile__show_other_first_levels() {
	$(".first__level__menu").each(function () {
		$(this).show();
	});
}

function mobile__slide_animation_second_level() {
	$(".first__level__menu.active")
		.find(".second__level_menu > ul > li > a")
		.each(function (i) {
			setTimeout(function () {
				$(".first__level__menu.active")
					.find(".second__level_menu > ul > li > a")
					.eq(i)
					.addClass("visible");
			}, 50 * i);
		});
}

function mobile__slide_animation_thrid_level() {
	$(".second__level_menu.active")
		.find("ul > li.active > ul > li > a")
		.each(function (i) {
			setTimeout(function () {
				$(".second__level_menu.active")
					.find("ul > li.active > ul > li > a")
					.eq(i)
					.addClass("visible");
			}, 50 * i);
		});
}

function mobile__hide_other_second_levels() {
	$(".second__level_menu > ul > li").each(function () {
		if (!$(this).hasClass("active")) {
			$(this).hide();

			// Remove visible states
			$(".second__level_menu > ul > li > ul > li > a").removeClass("visible");
		} else {
			return;
		}
	});
}

function mobile__show_other_second_levels() {
	$(".second__level_menu > ul > li").each(function () {
		$(this).show();
	});
}

function carousel__slide(direction) {
	$carousel.find(".carousel-item").each(function () {
		if ($(this).hasClass("active")) {
			var $current = $(this),
				slide__content = $current.find(".slide__content"),
				slide__bg = $current.find(".bg"),
				$viewport = viewport();

			// > mobile
			if ($viewport.width >= 720) {
				TweenMax.to(slide__content, 0.5, {
					left: "-100%",
					color: "#ffffff",
					ease: Power2.easeInOut,
					delay: 0.15,
				});

				TweenMax.to(slide__bg, 0.5, {
					transform: "scale(1.2)",
				});
			} else {
				TweenMax.to(slide__bg, 0.5, {
					transform: "scale(1.2)",
				});
			}

			// Transition
			setTimeout(function () {
				$carousel.carousel(direction);

				$("body").removeClass("page__loaded");
			}, 250);
		}
	});
}

function carousel__slided(e) {
	$carousel.find(".carousel-item").each(function () {
		if ($(this).hasClass("active")) {
			var $current = $(this),
				slide__content = $current.find(".slide__content"),
				slide__bg = $current.find(".bg"),
				$viewport = viewport();

			// > mobile
			if ($viewport.width >= 1024) {
				TweenMax.to(slide__content, 0.5, {
					left: "100px",
					ease: Power2.easeInOut,
				});
			}

			TweenMax.fromTo(
				slide__bg,
				0.5,
				{
					transform: "scale(1.2)",
				},
				{
					transform: "scale(1)",
				}
			);
		}
	});
}

$(document).keyup(function (e) {
	if (e.which === 39) {
		$carousel.carousel("next");
	} else if (e.which === 37) {
		$carousel.carousel("prev");
	}
});

$(window).scroll(function () {
	if ($(this).scrollTop() > 700) {
		$(".scrollup").addClass("activate");
	} else {
		$(".scrollup").removeClass("activate");
	}
});

function viewport() {
	var viewport = {
		width: $(window).width(),
		height: $(window).height(),
	};

	return viewport;
}
